import React from 'react'

function NotFound() {
  return (
    <div>Not_Found</div>
  )
}

export default NotFound